import { useState } from 'react';

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);
  const [isRejectShowing, setIsRejectShowing] = useState(false);
  const [isShowAddDiscount, setShowAddDiscount] = useState(false);
  function toggle() {
    setIsShowing(!isShowing);
  }

  function rejectToggle() {
    setIsRejectShowing(!isRejectShowing);
  }

  function addDiscount() {
    setShowAddDiscount(!isShowAddDiscount);
  }

  return {
    isShowing,
    toggle,
    rejectToggle,
    addDiscount,
    isRejectShowing,
    isShowAddDiscount
    
  }
};

export default useModal;


// WEBPACK FOOTER //
// ./web/components/admin/common/useModel.js